


























import { Vue } from "vue-property-decorator"
import type { url } from "@/@types/base"
import TsUpload from "@/components/upload.vue";

export default Vue.extend({
  name: "StadiumPhotoUpload",
  components: { TsUpload },
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
  },
  data() {
    return {
      host       : "https://data.taisam.cn",
      empty_url  : { path: "", url : "" } as url,
      stadium_photo: [
        { path: "", url : "" } as url
      ],
    }
  },
  methods: {
    init(data: any) {
      /* 附件2：收益与费用约定表 */
      if (data.stadium_photo_urls && data.stadium_photo_urls.length > 0) {
        const urls = []
        for (const v of data.stadium_photo_urls) {
          if (v != "") {
            const p = v.replace(this.host, "")
            urls.push({ path: p, url: `${this.host}${p}` })
          }
        }
        urls.push(this.empty_url)
        this.stadium_photo = urls
      }
    },
    handleChange(path: string, index: number) {
      if (path == "") {
        const temp = this.$deep_copy(this.stadium_photo)
        this.stadium_photo = []
        for (const k in temp) {
          if (k != String(index)) {
            if (Object.prototype.hasOwnProperty.call(temp, k)) {
              this.stadium_photo.push(temp[k])
            }
          }
        }
      } else this.stadium_photo[index] = { path, url: this.host + path }
      this.add_upload(this.stadium_photo)
    },
    add_upload(urls: url[]) {
      let count = 0
      for (const v of urls) {
        if (v.path == "") count += 1
      }
      if (count == 0) {
        urls.push({ path: "", url: "" })
      }
    },
    /* 处理 URL */
    handleURLS(data: url[]):string {
      const urls = []
      for (const v of data) if (v.path != "") urls.push(v.path)
      return urls.join(",")
    },
    submit() {
      const params = { estimate_id: this.id, stadium_photo_urls: this.handleURLS(this.stadium_photo) }
      this.$emit("save", params)
    },
    check(): boolean {
      return this.stadium_photo.length > 1
    },
  }
})

